
import React from "react";
import IntFileLogList from "../component/IntFileLogList";

const IntFileLogListContainer = () => (<IntFileLogList />)

export default IntFileLogListContainer;